export default {
      id: "color_charts_biome_white-usage",
      viewBox: "0 0 120 92",
      url: __webpack_public_path__ + "sprite.svg#color_charts_biome_white",
      toString: function () {
        return this.url;
      }
    }